import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Layer, Source} from 'react-map-gl';
import './MapPage.css';
import {AppNavigator} from "components/AppNavigator";
import data from "data/geoJson.json";
import {createSearchParams, useLocation, useNavigate} from "react-router-dom";
import type mapboxgl from 'mapbox-gl'
import {DefaultMap} from "../../components/map/DefaultMap";
import {getDataLayer, getDataLineLayer} from "../../components/map/mapUtils";
import {useColorMode} from "../../theme/ColorModeContext";
import {PointsOfInterest} from "./PointsOfInterest";
import {AucklandPoints} from "../../components/auckland/AucklandPoints";
import {SignInDialog} from "../../components/auth/SignInDialog";

type MapPageLocationState = {signInRedirect?: string} | null


export function MapPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const {mode} = useColorMode()
  const dataLayer = useMemo(() => getDataLayer(mode), [mode])
  const dataLineLayer = useMemo(() => getDataLineLayer(mode), [mode])

  // A guest who reached for a members-only page (see AccessController) lands
  // here with the map behind them and the sign-in dialog on top, then carries
  // on to where they were going.
  const signInRedirect = (location.state as MapPageLocationState)?.signInRedirect
  const [showSignIn, setShowSignIn] = useState<boolean>(false)

  // An effect rather than lazy initial state: a guest already sitting on /map
  // who taps Account gets routed back here, and depending on how the router
  // reconciles that, this component may re-render rather than remount.
  useEffect(() => {
    if (signInRedirect) setShowSignIn(true)
  }, [signInRedirect])

  // Drop the routing state so a refresh or back-navigation does not reopen it.
  const clearSignInState = useCallback(() => {
    setShowSignIn(false)
    if (signInRedirect) {
      navigate(location.pathname, {replace: true, state: null})
    }
  }, [navigate, location.pathname, signInRedirect])

  const onClick = useCallback((event: mapboxgl.MapLayerMouseEvent) => {
    const {
      features, lngLat, target
    } = event;
    const clickedFeature = features && features[0];

    if (clickedFeature?.properties?.id) {
      navigate({
        pathname: `/search/${clickedFeature.properties.id}`, search: `${createSearchParams({
          lat: `${lngLat.lat}`, lon: `${lngLat.lng}`, zoom: `${target.getZoom()}`,
        })}`,
      })
    }
  }, [navigate]);







  return (<>
    <div className="MapPage">
      <DefaultMap mapProps={{onClick}}>
        {  /* @ts-ignore */}
        <Source type="geojson" data={data}>
          <Layer {...dataLineLayer}/>
          <Layer {...dataLayer}/>
        </Source>
        <AucklandPoints/>
        <PointsOfInterest/>
      </DefaultMap>
    </div>
    <div className={"MapPageNavBar"}>
      <AppNavigator/>
    </div>
    {showSignIn && <SignInDialog
      onClose={clearSignInState}
      onSignedIn={() => {
        setShowSignIn(false)
        navigate(signInRedirect || "/account", {replace: true})
      }}
    />}
  </>);
}
